import { Actions, TreeDefaultNodeIds, permissionLevels } from "../../utils/constants";

export function authorizationHelper(dispatch, rootState) {
  function getRequiredPermissionLevel(action) {
    const permissionMap = {
      [Actions.READ]: permissionLevels.VIEWER,
      [Actions.COMMENT]: permissionLevels.COMMENTOR,
      [Actions.UPDATE]: permissionLevels.EDITOR,
      [Actions.CREATE]: permissionLevels.EDITOR,
      [Actions.SHARE]: permissionLevels.MANAGER,
      [Actions.MANAGE]: permissionLevels.MANAGER,
      [Actions.DELETE]: permissionLevels.ADMIN,
    };
    return permissionMap[action] || permissionLevels.NONE;
  }

  async function getProcessBasedPermission(designId) {
    return dispatch("pdesigns/getDesignPermissions", designId, { root: true });
  }

  async function getTeamBasedPermission(teamId) {
    return await dispatch("pdesigns/getTeamPermission", teamId, { root: true });
  }

  function checkPermission(entityPermission, action) {
    const requiredPermission = getRequiredPermissionLevel(action);
    if (!entityPermission || !entityPermission.role) {
      console.error("Invalid permission object or missing role.");
      return false;
    }

    const userPermissionLevel = permissionLevels[entityPermission.role] || permissionLevels.NONE;
    return userPermissionLevel >= requiredPermission;
  }

  async function checkTeamPermission(teamId, action) {
    try {
      if (teamId === TreeDefaultNodeIds.Private || teamId === null) return true;
      if (teamId === TreeDefaultNodeIds.Default) return false;
      const teamPermission = await getTeamBasedPermission(teamId);
      return checkPermission(teamPermission, action);
    } catch (error) {
      console.error("Error checking team-based permission:", error.message);
      return false;
    }
  }

  async function checkProcessPermission(designId, action, currentPermission = null) {
    try {
      let processPermission = currentPermission;
      if (!processPermission) {
        processPermission = await getProcessBasedPermission(designId);
      }
      return checkPermission(processPermission, action);
    } catch (error) {
      console.error("Error checking process-based permission:", error.message);
      return false;
    }
  }

  return {
    checkTeamPermission,
    checkProcessPermission,
    getTeamBasedPermission,
    getProcessBasedPermission,
  };
}
